<template>
    <transition name="modal" >
      <div class="modal-mask">
        <div class="modal-container text-center" ref="modalContainer">
            <span class="close" @click="externalLinkModalOpen=false">
                <svg style="width:20px; height: 20px" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/>
                </svg>
            </span>
           <div class="modal-body ">
                <slot name="body">
                    <h2><strong>You are now leaving {{ currentSiteName }}</strong></h2>
                    <p><a :href="newSiteHref" class="btn">continue to {{ newDomain }}</a></p>
                </slot>
            </div>
        </div>
      </div>
    </transition>
</template>

<script>
export default {
    props: ['currentSiteName','newSiteHref'],

    computed: {
        newDomain: function(){
            var urlParts = this.newSiteHref.replace('http://', '').replace('https://', '').split(/[/?#]/);
            return urlParts[0];
        }
    }
}
</script>